/**
 * Simple client-side event emitter implementation.
 * Replaces the Node.js 'events' dependency for browser-compatibility in Webpack 5.
 */
export class EventEmitter {
  private listeners: Record<string, Function[]> = {};

  on(event: string, listener: Function): this {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(listener);
    return this;
  }

  off(event: string, listener: Function): this {
    if (!this.listeners[event]) return this;
    this.listeners[event] = this.listeners[event].filter(l => l !== listener);
    return this;
  }

  emit(event: string, ...args: any[]): boolean {
    if (!this.listeners[event]) return false;
    this.listeners[event].forEach(listener => {
      try {
        listener(...args);
      } catch (err) {
        console.error(`Error in EventEmitter listener for key ${event}:`, err);
      }
    });
    return true;
  }

  removeAllListeners(event?: string): this {
    if (event) {
      delete this.listeners[event];
    } else {
      this.listeners = {};
    }
    return this;
  }
}
